  
document.addEventListener("DOMContentLoaded", function(){


  
function insertAtCaret(text) {
  const textarea = document.querySelector('#charms')
  textarea.setRangeText(
    text,
    textarea.selectionStart,
    textarea.selectionEnd,
    'end'
  )
}


var xpath  = "//span[contains(text(),'Charms')]";
  var matchingElement = document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
  $(matchingElement).parent().hide()
  $('.Popover__ValueList').find('button[data-value="None"]').click();
  
$('.heart-icon').unbind().click(function() {
  		 var heartOrNone = 'None'
         $(this).toggleClass('heart-selected')
         $('#heartRadio').click();
  		
  		if($(this).hasClass('heart-selected')) {
        

          
          
          if($('#charms').val().indexOf('♥') == -1) {
            if(document.querySelector('#charms').value.length < 6){
             insertAtCaret('♥');
              var input = document.createElement("input");
              input.name = "items[1]id";
              input.value = "39500385615970"; // set the CSS class
              input.type = "hidden";
              input.className = "hearticonproduct";
              document.querySelector(".product-form").appendChild(input);
              
              
              
             $('#charms').keyup();

            }
  												}
             

              $('select[id*="product-select"]').find('option[value="'+productID+'"]').attr('selected','selected');
              var heartOrNone = 'Heart'			
        
        }
  
 		 else {
          $(".hearticonproduct").remove();
          $('#charms').attr('maxlength','5')
		  $('#charms').keyup();
          $charmVal = $('#charms').val();
          $charmVal.replace('♥','')
          console.log($charmVal.indexOf('♥'))
          var position = $charmVal.indexOf('♥');//its 1 based
          var newStr = $charmVal.substring(0,position) + $charmVal.substring(position+1, $charmVal.length);
          $('#charms').val(newStr);    
          $('.char-count').text($(".charms-input").val().length+'/5 characters')
		}
  
    
  
});  
  
  $(function() {
  $(".charms-input").on("keyup change", function(event) {
	console.log("keyup")
    
    
    
    var value = $(this).val();
    var value = $($('#charms')).val();
    
    if (value.indexOf('♥') != -1) {
	console.log("yep")
	$("#heartRadio").prop('checked', true);
	$("#eyeRadio").prop('checked', false);     }
    
    if (value.indexOf('♥') == -1) {
	console.log("nope")
	$("#heartRadio").prop('checked', false);
	$("#eyeRadio").prop('checked', true);   
    }
    
    
    
    
    
    
    
     if (value.indexOf('♥') != -1 && $('.heart-icon').hasClass('heart-selected')==false ) {
		$('.heart-icon').addClass('heart-selected');
	console.log("var")
       
    }
    
     else if (value.indexOf('♥') == -1 && $('.heart-icon').hasClass('heart-selected')==true ) {
		$('.heart-icon').removeClass('heart-selected');
       
       
	console.log("yok")

    }
  
    
    $('.char-count').text(value.length+'/6 characters')
    if (value.indexOf('!') != -1) {
      $(this).val(value.replace("!", ""));
    }
    if (value.indexOf('$') != -1) {
     $(this).val(value.replace("$", ""));
    }
    
    /* you can add exludes like that */
     if (value.indexOf('@') != -1) {
     $(this).val(value.replace("@", ""));
    }
    
     if (value.indexOf('+') != -1) {
     $(this).val(value.replace("+", ""));
    }
    
     if (value.indexOf('#') != -1) {
     $(this).val(value.replace("#", ""));
    }
    
    // if (value.indexOf('&') != -1) {
    //  $(this).val(value.replace("&", ""));
    // }
        
    if (value.indexOf('.') != -1) {
     $(this).val(value.replace(".", ""));
    }
    
    if (value.indexOf('%') != -1) {
     $(this).val(value.replace("%", ""));
    }
 	/* you can add exludes like that */
    
    
  })
});
  
  function findTrueVariant(option, color, heartOrNone) {
    console.log('fonksiyon başladı. Color:'+ color)
    option.each(function() {
      
     if( ($(this).text().indexOf(color) >= 0) && ($(this).text().indexOf(heartOrNone)>=0) ) {
        	$('select[id*="product-select"]').find('option').removeAttr('selected');
			$(this).attr('selected','selected')
     }  
      
     
});
  
}
  
  setInterval(function(){ 
    var value = $($('#charms')).val();
    
    if (value.indexOf('♥') != -1) {
    $("#heartRadio").prop('checked', true);
	$("#eyeRadio").prop('checked', false);       
    }  
    
    if (value.indexOf('♥') == -1) {
    $("#heartRadio").prop('checked', false);
	$("#eyeRadio").prop('checked', true);       
    }
        
        
        
     if (value.indexOf('♥') != -1 && $('.heart-icon').hasClass('heart-selected')==false ) {
		$('.heart-icon').addClass('heart-selected');
	$("#heartRadio").prop('checked', true);
	$("#eyeRadio").prop('checked', false);   
     }
    
     else if (value.indexOf('♥') == -1 && $('.heart-icon').hasClass('heart-selected')==true ) {
		$('.heart-icon').removeClass('heart-selected');
	$("#heartRadio").prop('checked', false);
	$("#eyeRadio").prop('checked', true);   
     }
  
  
  
  }, 50);

  

});


